// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { TransferRule } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Rule/Transfer';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useTransferRules: (
  operator: string,
  registrar: string,
) => UseQueryResult<TemplateContract<TransferRule>[], string> = (operator, registrar) => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryTransferRules', offset, operator, registrar, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryTransferRules(offset!, operator, registrar);
    },
    enabled: !!offset,
  });
};

export default useTransferRules;
